import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { GroupedEditorActor } from 'src/app/models/requestEditor';
import { RequestBuilderService } from 'src/app/components/requestbuilder/request-builder.service';
import { DocumentModel } from 'src/app/models/document.model';
import { Subscription } from 'rxjs';
import { DocumentActor } from 'src/app/models/actors';
import { LoggingService } from 'src/app/services/logging.service';
import { SingleOrDefault } from 'src/app/_helpers/ArrayExtensionMethodHelper.functions';
import { ChangeActionsInPersonSendGroupModel } from 'src/app/models/api/create-sendgroup.model';

@Component({
    selector: 'app-actions-by-person',
    templateUrl: './actions-by-person.component.html',
    styleUrl: './actions-by-person.component.scss'   
})
export class ActionsByPersonComponent implements OnInit, OnDestroy {
    private _actorInSendgroup!: GroupedEditorActor;

    @Input() set actorInSendgroup(val: GroupedEditorActor){
        this._actorInSendgroup = val;
        if(this._actorInSendgroup){
            this.getGroupedActorById(this._actorInSendgroup.id)
        }
    }
    @Input() sortingAllowed: boolean = false;
    @Input() lastItemOfPersonsInSendgroup: boolean = false;
    actionsByPerson: any;
    documents: DocumentModel[] = [];
    actors: DocumentActor[] = [];
    persons: DocumentActor[] = [];

    private documentsSubscription!: Subscription;
    private actorsSubscription!: Subscription;
    private personsSubscription!: Subscription;

    constructor(protected requestBuilderService: RequestBuilderService) {
        this.documentsSubscription = this.requestBuilderService.documents$.subscribe(documents => {
            this.documents = documents;
        })
        this.actorsSubscription = this.requestBuilderService.actors$.subscribe(actors => {
            this.actors = actors;
            if (this._actorInSendgroup) {
                this.actionsByPerson = this.getGroupedActorById(this._actorInSendgroup.id);
            }
        })
        this.personsSubscription = this.requestBuilderService.persons$.subscribe(persons => {
            this.persons = persons;
        })
    }

    ngOnInit(): void {
        if (this._actorInSendgroup) {
            this.actionsByPerson = this.getGroupedActorById(this._actorInSendgroup.id);
        }
    }

    ngOnDestroy(): void {
        if (this.documentsSubscription) {
            this.documentsSubscription.unsubscribe();
        }
        if (this.actorsSubscription) {
            this.actorsSubscription.unsubscribe();
        }
        if (this.personsSubscription) {
            this.personsSubscription.unsubscribe();
        }
    }

    public getGroupedActorById(id: string) {
        let actorWithActions: any[] = [];
        let actorActions = this.actors.filter(action => action.dossierPersonId === id);
        actorActions.forEach(actorAction => {
            actorWithActions.push({
              id: actorAction.id,
              dossierPersonId: actorAction.dossierPersonId,
              actionType: actorAction.action,
              order: actorAction?.order,
              credits: actorAction?.suggestedCreditCost,
              documentName: SingleOrDefault(this.documents, 'id', actorAction?.documentId)?.name,
              grouped: false
            });
        })

        return actorWithActions.sort((a, b) => (a.order < b.order ? -1 : 1));
    }

    async drop(event: any) {
        moveItemInArray(this.actionsByPerson, event.previousIndex, event.currentIndex);
        let actorPrevious: DocumentActor = this.actionsByPerson[event.previousIndex];
        let actorCurrent: DocumentActor = this.actionsByPerson[event.currentIndex];
        let actorsToUpdate: ChangeActionsInPersonSendGroupModel[] = [];
        this.actionsByPerson.forEach((action:any, index: number) => {            
            action.order = index + 1;
            actorsToUpdate.push({
                InviteGuid: action.id,
                Order: action.order
            });
        });
        // TO DO, create right change order call for changing order of actions by person
        this.requestBuilderService.changeOrderActorsInSendGroup(actorsToUpdate, this.actionsByPerson[0].dossierPersonId);
    }
}